import { HttpService, LanguageService, LocaleService } from '@philips-internal/oswald-ui-core/lib/services';
import { Endpoint } from '../constants/endpoints';

interface Locale {
  language: string;
  locale: string;
  supportedLocales: string[];
}

function setConfigurationLocale(): Promise<void> {
  return HttpService.get(Endpoint.GET_CONFIGURATION_LOCALE)
    .then(response => {
      const { language , locale} = response.body as Locale;
      LanguageService.setCurrentLanguage(language);
      LocaleService.setCurrentLocale(locale);
    });
}

function setUserLocale(): void {
  HttpService.get(Endpoint.GET_USER_LOCALE)
    .then(response => {
      const { language, locale } = response.body as Locale;
      LanguageService.setCurrentLanguage(language);
      LocaleService.setCurrentLocale(locale);
    });
}

export { setConfigurationLocale, setUserLocale };
